<template>
  <div class="header flex_space-b f_w_5 font_20">
    <div class="logo" @click="toPage(0)">
      <img src="../assets/logo.png" class="logo" alt="" />
    </div>
    <div class="nav flex_space-b">
      <div class="nav_item" :class="path== '/'?'color_91':''" @click="toPage(0)">Home</div>
      <div class="nav_item" :class="path== '/overview'?'color_91':''" @click="toPage(1)">Faq</div>
    </div>
    <div class="link">
      <div class="link_item color_91 cur" @click="lunchApp">
        Launch App
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      path: '/'
    }
  },
  methods:{
    toPage: function (type) {
      this.path = '/'
      if(type == 1) {
        this.path = '/overview'
      }
      this.$router.push({
        path: this.path
      })
    },
    lunchApp: function () {
      let linkUrl = 'https://app.xfilab.org'
      window.open(linkUrl, "_blank");
    }
  }
}
</script>
<style lang="less" scoped>
.header {
  width: 85vw;
  height: auto;
  overflow: hidden;
  margin: 10px auto;
  .logo {
    cursor: pointer;
  }
  .nav {
    .nav_item {
      font-weight: bold;
      cursor: pointer;
    }
    .nav_item:nth-child(1) {
      margin-right: 30px;
    }
  }
  .link {
    .link_item {
      background: rgba(145, 101, 255, .2);
      font-size: 16px;
      padding: 10px 15px;
    }
  }
}
@media (max-width:414px) {
  .header {
    width: 90vw;
    .logo {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: center;
      align-items: center;
      img {
        width: 55px;
      }
    }
    .nav {
      font-size: 16px;
      .nav_item:nth-child(1) {
        margin-right: 10px;
      }
    }
    .link {
      .link_item {
        font-size: 14px;
        padding: 5px 7px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue